import { z } from 'zod'
import type { TopicList } from '../model/contracts'

const topicListSchema = z.object({
  id: z.string(),
  name: z.string(),
  keywords: z.array(z.string()).default([]),
  platform: z.enum(['all', 'facebook', 'x', 'twitter', 'threads']).default('all'),
  isActive: z.boolean().default(true),
  isPublic: z.boolean().default(false),
  slug: z.string().default(''),
  createdAt: z.string(),
  updatedAt: z.string(),
})

const topicListResponseSchema = z.object({
  meta: z.object({
    total: z.number(),
    page: z.number(),
    limit: z.number(),
  }),
  data: z.array(topicListSchema),
})

export type TopicListResponse = z.infer<typeof topicListResponseSchema>

export function parseTopicListResponse(data: unknown): TopicListResponse {
  const result = topicListResponseSchema.safeParse(data)
  if (!result.success) {
    console.error('TopicListResponse Validation Failed:', z.treeifyError(result.error))
    console.error('Raw Payload:', data)
    throw new Error('Invalid TopicListResponse contract')
  }
  return result.data
}

export function parseTopicList(data: unknown): TopicList {
  const result = topicListSchema.safeParse(data)
  if (!result.success) {
    console.error('TopicList Validation Failed:', z.treeifyError(result.error))
    console.error('Raw Payload:', data)
    throw new Error('Invalid TopicList contract')
  }
  return result.data as TopicList
}
